export default __webpack_public_path__ + "static/img-home-feature-career-bg-f0bffe8dda3d59dd4f66e6879c34aba3.png";